<template>
  <v-col :cols="12" :sm="12" :md="12">
    <DataTable
      v-show="showSkeletonTable == false"
      :tableTitle="'Notas importadas'"
      :newRowmodalButtonText="'importar nota'"
      :tableHeader="headers"
      :tableRows="listNotas"
      :totalItens="total"
      v-on:datatable-update-page="updatePage"
      v-on:datatable-update-search="updateSearch"
      v-on:datatable-newrow="onDataTableInsertRow"
      v-on:datatable-viewrow="onDataTableViewRow"
      v-on:datatable-deleterow="modalDeExcluir"
      :isViewNota="true"
      :isDel="true"
    ></DataTable>
    <ModalCustomSize
      :modalSize="modalCustomSize.modalSize"
      :isTheModalOpen="modalCustomSize.isOpen"
      :modalButtonText="modalCustomSize.buttonText"
      :modalFormTitle="modalCustomSize.formTitle"
      :modalType="modalCustomSize.modalType"
      :isLoadingRequestDisable="modalCustomSize.isLoadingRequestDisable"
      :isModalButtonVisible="modalCustomSize.isButtonsVisible"
      :isModalButtonDisabled="modalCustomSize.isButtonsDisabled"
      v-on:formmodal-close="modalCustomSize.isOpen = false"
      v-on:formmodal-action="onFormModalAction"
    >
      <v-alert type="error" v-show="error">{{ error }}</v-alert>

      <v-file-input v-model="notaImportada" placeholder="Importar nota" label="Importar Nota" prepend-icon="mdi-paperclip" @change="readXML($event)">
        <template v-slot:selection="{ text }">
          <v-chip small label color="primary">
            {{ text }}
          </v-chip>
        </template>
      </v-file-input>

      <v-expand-transition v-if="itensImportados.length > 0">
        <v-row>
          <v-col cols="2">
            <v-checkbox v-model="tipo" :false-value="0" :true-value="1" label="Sub estoque 2"></v-checkbox>
          </v-col>
          <v-col cols="10">
            <v-autocomplete v-model="enderecoSelecionado" :items="listaEndereco" label="Selecionar unidade" @change="validarNota()"></v-autocomplete>
          </v-col>
          <v-col cols="6">
            <v-text-field v-model="itensImportados[0].nomeFantasiajEmpresa" label="Nome fantasia" disabled class="mx-4"></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field v-model="itensImportados[0].cnpjEmpresa" label="CNPJ" class="mx-4" disabled></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field v-model="itensImportados[0].numeroNota" label="Número da nota" class="mx-4" disabled></v-text-field>
          </v-col>

          <v-col cols="6">
            <v-text-field v-model="itensImportados[0].valorTotalNota" label="Valor Total" class="mx-4" disabled></v-text-field>
          </v-col>

          <v-data-table transition="expand-transition" :headers="headersItensImportados" :items="itensImportados" class="elevation-1" :search="search" disable-sort>
            <template v-slot:top>
              <v-text-field v-model="search" label="Buscar" class="mx-4"></v-text-field>
            </template>

            <template v-slot:[`item.quantidadeItem`]="{ item }">
              <!--- Trecho específico para tratamento do tipo tarefa --->
              <v-text-field style="max-width:250px" v-model="item.quantidadeItem" label="Quantidade Recebida" single-line @keypress="(event) => filter(event)"></v-text-field>
            </template>
          </v-data-table>
        </v-row>
      </v-expand-transition>
    </ModalCustomSize>

    <ModalCustomSize :modalSize="modalCustomSizeNota.modalSize" :isTheModalOpen="modalCustomSizeNota.isOpen" :modalFormTitle="modalCustomSizeNota.formTitle" :modalType="modalCustomSizeNota.modalType" v-on:formmodal-close="modalCustomSizeNota.isOpen = false">
      <v-row>
        <v-col cols="6">
          <v-text-field v-model="modalCustomSizeNota.actualEdit.nomeEmpresa" label="Nome da empresa" readonly></v-text-field>
        </v-col>
        <v-col cols="6">
          <v-text-field v-model="modalCustomSizeNota.actualEdit.cnpjEmpresa" label="CNPJ da empresa" readonly></v-text-field>
        </v-col>
        <v-col cols="6">
          <v-text-field v-model="modalCustomSizeNota.actualEdit.numeroNota" label="Número da nota" readonly></v-text-field>
        </v-col>

        <v-col cols="6">
          <v-text-field v-model="modalCustomSizeNota.actualEdit.valorNota" label="Valor total da nota" readonly></v-text-field>
        </v-col>
        <v-col cols="12">
          <v-data-table transition="expand-transition" :headers="headersItensNotas" :items="modalCustomSizeNota.actualEdit.listItens" class="elevation-1" :search="search" disable-sort>
            <template v-slot:top>
              <v-text-field v-model="search" label="Buscar" class="mx-4"></v-text-field>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </ModalCustomSize>
    <DeleteItemModal :showModalDelete="modalDelete.abrir" :textModalDelete="modalDelete.texto" :buttomTextModalDelete="'Remover'" v-on:close-modal="modalDelete.abrir = false" v-on:on-response-modal-delete="excluir"></DeleteItemModal>
  </v-col>
</template>

<script>
import axios from "../plugins/axios";
import axiosZSaude from "../plugins/axios_integracao";
import DataTable from "../components/DataTable2";
import ModalCustomSize from "../components/ModalCustomSize";
import DeleteItemModal from "../components/DeleteItemModal.vue";

import store from "@/store/index";
export default {
  components: {
    DataTable,
    ModalCustomSize,
    DeleteItemModal,
  },

  watch: {
    enderecoSelecionado() {
      if (this.enderecoSelecionado) {
        this.modalCustomSize.isButtonsDisabled = this.notaValidada;
      } 
    },
  },

  data: () => ({
    tipo: 0,
    error: null,
    search: null,
    page: 1,
    total: null,
    notaImportada: null,
    notaValidada: false,
    showSkeletonTable: false,
    headers: [
      {
        text: "Id",
        value: "historicoEntrada.numeroHistoricoEntrada",
      },
      {
        text: "Número nota",
        value: "historicoEntrada.descricaoNumeroNota",
      },
      {
        text: "Nome da empresa",
        value: "historicoEntrada.descricaoNomeEmpresa",
      },
      {
        text: "Valor da nota",
        value: "historicoEntrada.valorTotalNota",
      },
      {
        text: "Data de emissão",
        value: "historicoEntrada.dataEmissao",
      },
      {
        text: "Ações",
        value: "actions",
        sortable: false,
      },
    ],
    headersItensImportados: [
      {
        text: "Nome Produto",
        value: "nomeProduto",
      },
      {
        text: "Lote",
        value: "lote",
      },
      {
        text: "Validade",
        value: "validade",
      },
      {
        text: "Unidade de medida",
        value: "unidadeMedida",
      },
      {
        text: "Quantidade",
        value: "quantidadeItem",
      },
      {
        text: "Valor unitario",
        value: "valorUnitario",
      },
    ],
    headersItensNotas: [
      {
        text: "Nome Produto",
        value: "nomeItem",
      },
      {
        text: "Lote",
        value: "lote",
      },
      {
        text: "Validade",
        value: "validade",
      },
      {
        text: "Quantidade Recebida",
        value: "quantidadeEntrada",
      },
      {
        text: "Valor unitário",
        value: "valorItemIndividual",
      },
    ],
    listNotas: [],
    listaEndereco: [],
    itensImportados: [],
    enderecoSelecionado: null,
    modalCustomSize: {
      modalSize: "1080",
      isOpen: false,
      buttonText: "",
      formTitle: "",
      isEdit: false,
      isButtonsVisible: true,
      isButtonsDisabled: true,
      isLoadingRequestDisable: false,
      actualEdit: {
        numeroNota: null,
        nomeEmpresa: null,
        valorNota: null,
        dataEmissao: null,
      },
    },
    modalCustomSizeNota: {
      modalSize: "1080",
      isOpen: false,
      buttonText: "",
      formTitle: "",
      isEdit: false,
      isButtonsVisible: true,
      isButtonsDisabled: true,
      isLoadingRequestDisable: false,
      actualEdit: {
        numeroNota: null,
        nomeEmpresa: null,
        valorNota: null,
        dataEmissao: null,
        cnpjEmpresa: null,
        listItens: [],
      },
    },
    loading: false,
    modalDelete: {
        abrir: false,
        texto: "Deseja inativar a nota e seu valor?",
        dadosDelete: {
          numeroNota: null,
          numeroHistoricoEntrada: null,
        },
    },
    config: {
      headers: {
        "Content-Type": "application/json",
        "x-auth-token": store.state.token,
      },
    },
  }),

  created() {
    this.initialize();
  },

  methods: {
    onDataTableInsertRow() {
      this.search = null;
      this.loading = true;
      this.modalCustomSize.isOpen = true;
      this.modalCustomSize.isEdit = false;
      this.modalCustomSize.buttonText = "Concluir";
      this.modalCustomSize.formTitle = "Enviar nota";
      this.itensImportados = [];
      this.notaImportada = null;
      this.loading = false;
    },

    onDataTableViewRow(nota) {
      this.search = null;
      this.loading = true;
      this.modalCustomSizeNota.isOpen = true;
      this.modalCustomSizeNota.isEdit = false;
      this.modalCustomSizeNota.buttonText = "Concluir";
      this.modalCustomSizeNota.formTitle = "Visualizar nota";
      this.modalCustomSizeNota.actualEdit.numeroNota = nota.historicoEntrada.descricaoNumeroNota;
      this.modalCustomSizeNota.actualEdit.nomeEmpresa = nota.historicoEntrada.descricaoNomeEmpresa;
      this.modalCustomSizeNota.actualEdit.valorNota = nota.historicoEntrada.valorTotalNota;
      this.modalCustomSizeNota.actualEdit.cnpjEmpresa = nota.historicoEntrada.descricaoCnpjEmpresa;
      this.modalCustomSizeNota.actualEdit.listItens = nota.listItem;
      this.loading = false;
    },

    async excluir() {
        try {
          console.log(this.modalDelete.dadosDelete);
          this.loading = true;
          await axios.delete("inativaNota", {
            data: this.modalDelete.dadosDelete,
            headers: this.config.headers,
          });

          this.modalDelete.abrir = false;
          this.mostrarSkeleton = true;
          this.initialize();
        } catch (error) {
          console.log(error);
        } finally {
          this.loading = false;
        }
      },

    async modalDeExcluir(nota) {
      this.modalDelete.abrir = true;
      this.modalDelete.dadosDelete.numeroNota = nota.historicoEntrada.descricaoNumeroNota
      this.modalDelete.dadosDelete.numeroHistoricoEntrada = nota.historicoEntrada.numeroHistoricoEntrada
      console.log(nota)
    },

    async updatePage(pagination) {
      this.page = pagination.page;
      await this.initialize();
    },

    async updateSearch(search) {
      if (search) {
        this.search = search;
        this.page = 1;
        await this.initialize();
      } else {
        this.page = 1;
      }
    },

    async validarNota() {
        const config = {
          headers: {
            "Content-Type": "application/json",
            "x-auth-token": store.state.token,
          },
        };
        let validar = await axios.put(
          "validarNota",
          { numeroNota: this.itensImportados[0].numeroNota },
          config
        );
        this.notaValidada = validar.data;
        if(this.enderecoSelecionado == null){
          this.modalCustomSize.isButtonsDisabled = true
        }else{
          this.modalCustomSize.isButtonsDisabled = this.notaValidada;
        }
        if (validar.data) {
            this.error = "A nota inserida já existe no banco de dados do sistema";
          } else {
            this.error = null;
          }
      },

    async onFormModalAction() {
      try {
        await axios.post(
          "itemImport",
          {
            anexoFile: this.itensImportados,
            dispensaAutomatica: true,
            numeroenderecoordemservico: this.enderecoSelecionado,
            tipo: this.tipo,
          },
          this.config
        );

        if (this.verificaUnidade(this.enderecoSelecionado)) {
          const dadosZSaude = {
            numeroUnidade: this.retornaNumeroUnidadeZSaude(this.enderecoSelecionado),
            nomeRazazaoSocial: null,
            nomeFantasia: this.itensImportados[0].nomeFantasiajEmpresa,
            descricaoCnpj: this.itensImportados[0].cnpjEmpresa,
            dataEmissao: this.itensImportados[0].dataEmissao,
            valorTotal: this.itensImportados[0].valorTotalNota,
            descricaoNumeroNota: this.itensImportados[0].numeroNota,
            indicadorTipo: this.tipo,
            itensImportados: this.itensImportados,
          };

          await axiosZSaude.post("importarnota", dadosZSaude, this.config);
        }

        this.modalCustomSize.isOpen = false;
        this.initialize();
      } catch (error) {
        console.log(error);
      }
    },

    async initialize() {
      const searchListNotas = await axios.put("historicoEntrada", { numeroEndereco: null, pagina: this.page, search: this.search }, this.config);
      this.listNotas = searchListNotas.data;
      this.total = this.listNotas[0].historicoEntrada.total;

      const searchListEndereco = await axios.get("enderecoordemservico", this.config);
      this.listaEndereco = searchListEndereco.data.map(function(enderecoSelecionado) {
        return {
          text: enderecoSelecionado.nomeEndereco,
          value: enderecoSelecionado.numeroEnderecoOrdemServico,
        };
      });
    },

    async readXML(file) {
      this.itensImportados = [];
      if (file) {
        if (file.type == "text/xml") {
          this.error = null;
          const readXML = await this.getXML(file);
          let objXML = await this.parseFile(readXML);
          this.getItens(objXML, objXML.getElementsByTagName("prod"), objXML.getElementsByTagName("infAdProd"), objXML.getElementsByTagName("ide")[0].childNodes[6].innerHTML, objXML.getElementsByTagName("det"));
          this.validarNota()

        } else {
          this.error = "Esse arquivo não está em um formato válido, por favor envie um XML";
          this.notaImportada = null;
          this.modalCustomSize.isButtonsDisabled = true;
        }
      } else {
        this.error = null;
        this.notaImportada = null;
        this.modalCustomSize.isButtonsDisabled = true;

      }
    },

    async parseFile(file) {
      let doc = new DOMParser().parseFromString(file, "text/xml");
      return doc;
    },

    async getXML(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsText(file);

        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    },

    getItens(nota, listItens, loteImport, dataEmissao, xmlRecebido) {
      const itensConvertidosArray = Array.prototype.slice.call(listItens);

      for (let i = 0; i < itensConvertidosArray.length; i++) {

        let lote;
        let validade;

        let elementoXml = xmlRecebido[i].getElementsByTagNameNS("http://www.portalfiscal.inf.br/nfe", "infAdProd")[0];

        // Verifique se o elemento existe antes de tentar acessar seu conteúdo
        if (elementoXml) {
            // Obtenha o valor dentro da tag infAdProd
            let valor = elementoXml.textContent.trim();
            lote = valor.split("-")[1].split("(")[1]
            validade = valor.split("-")[2].split(")")[0]
        } else {
            lote = null
            validade = null
        }
    

        this.itensImportados.push(
          new Object({
            codigoProduto: itensConvertidosArray[i].getElementsByTagName("cProd")[0].innerHTML,
            nomeProduto: itensConvertidosArray[i].getElementsByTagName("xProd")[0].innerHTML,
            unidadeMedida: itensConvertidosArray[i].getElementsByTagName("uTrib")[0].innerHTML,
            quantidadeItem: itensConvertidosArray[i].getElementsByTagName("qTrib")[0].innerHTML,
            descricaoTela: "itensNDispensados",
            lote: lote,
            validade: validade,
            valorUnitario: itensConvertidosArray[i].getElementsByTagName("vUnTrib")[0].innerHTML,
            cnpjEmpresa: nota.getElementsByTagName("emit")[0].childNodes[0].innerHTML,
            razaoSocialEmpresa: nota.getElementsByTagName("emit")[0].childNodes[1].innerHTML,
            nomeFantasiajEmpresa: nota.getElementsByTagName("emit")[0].childNodes[2].innerHTML,
            valorTotalNota: nota.getElementsByTagName("total")[0].childNodes[0].childNodes[8].innerHTML,
            numeroNota: nota.getElementsByTagName("infProt")[0].childNodes[2].innerHTML,
            dataEmissao: dataEmissao.split("T")[0],
          })
        );
      }
    },

    filter: function(evt) {
      evt = evt ? evt : window.event;
      let expect = evt.target.value.toString() + evt.key.toString();

      if (!/^[0-9]*?[0-9]*$/.test(expect)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },

    verificaUnidade(numeroUnidade) {
      switch (numeroUnidade) {
        case 67:
          return true;
        case 66:
          return true;
        case "67":
          return true;
        case "66":
          return true;
        default:
          return false;
      }
    },

    retornaNumeroUnidadeZSaude(numeroUnidade) {
      switch (numeroUnidade) {
        case 67:
          return 10;
        case 66:
          return 11;
        case '67':
          return 10;
        case '66':
          return 11;
      }
    },
  },
 
};
</script>

<style></style>
